import type { AxiosError } from "axios";
import type { KeyedMutator } from "swr";
import type { Order } from "@/features/dmManagement/types";
import { GetOrdersAPI } from "@/features/dmManagement/api";
import { useApiClient } from "@/hooks/useApiClient";

interface UseOrdersParams {
  status?: string;
  ordering?: string;
}

interface UseOrdersReturn {
  orders: Order[] | undefined;
  isLoading: boolean;
  error: AxiosError | undefined;
  mutate: KeyedMutator<Order[]>;
}

/**
 * 発注一覧を取得するカスタムフック。
 * ステータスやソート順のパラメータを指定して、フィルタリングされた発注一覧を取得できる。
 */
export const useOrders = (params?: UseOrdersParams): UseOrdersReturn => {
  const { apiClient } = useApiClient();
  const { data, isLoading, mutate, error } = GetOrdersAPI(apiClient, params);

  return {
    orders: data,
    isLoading,
    error,
    mutate,
  };
};
